import { AbstractObject as KnxAbstractObject } from '@knxlab/models';

export default class AbstractObject extends KnxAbstractObject {

}
